import { Question6Type } from '../desktop/SectionFive/components/stepFour/schema/examSurveySchema'

const QUESTION_SUBJECT_MAP: {
  [key in string]: keyof Question6Type
} = {
  '1': 'suri',
  '2': 'churi',
}

export default QUESTION_SUBJECT_MAP
